import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Typography } from "@material-ui/core";
import MaterialWrapper from "../Material/MaterialWrapper";
const useStyles = makeStyles({
  root: {
    padding: "5% 10%",
    background: "biege",
  },
});

export default function FooterDescription({ title, content }) {
  const classes = useStyles();
  return (
    <MaterialWrapper>
      <section dir="rtl" className={classes.root}>
        <Typography variant="h5">{title}</Typography>
        <br />
        <Typography variant="body1">{content}</Typography>
      </section>
    </MaterialWrapper>
  );
}
